import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        <div className="relative min-h-screen bg-void flex items-center pt-20 overflow-hidden">

            {/* 1. The Engineering Grid Background */}
            <div className="absolute inset-0 bg-grid-pattern opacity-30 pointer-events-none" />

            {/* 2. A subtle spotlight from top-left (Lighting) */}
            <div className="absolute top-0 left-0 w-[800px] h-[500px] bg-neon-blue/10 blur-[150px] rounded-full pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

                {/* LEFT COLUMN: The Typography */}
                <div className="text-left">
                    {/* Status Indicator */}
                    <div className="flex items-center gap-3 mb-8">
                        <div className="h-px w-8 bg-neon-blue"></div>
                        <span className="text-neon-blue font-mono text-sm tracking-widest uppercase">
                            Top Orion Engineering // 2026
                        </span>
                    </div>

                    {/* Massive Headline - SEO OPTIMIZED H1 */}
                    <h1 className="text-6xl md:text-8xl font-black text-white leading-[0.9] mb-8 font-display">
                        ENGINEERING <br />
                        <span className="text-transparent bg-clip-text bg-gradient-to-br from-white via-gray-300 to-gray-600">
                            LEAK-FREE SAAS.
                        </span>
                    </h1>

                    {/* Paragraph - SEO OPTIMIZED with Long-tail Keywords */}
                    <p className="text-gray-400 text-lg md:text-xl leading-relaxed max-w-lg mb-10 font-light border-l border-white/10 pl-6">
                        Top Orion builds <span className="text-white font-medium">custom SaaS solutions</span> including a <span className="text-white font-medium">live restaurant margin tracker</span> and automated <span className="text-white font-medium">fitness trainer booking systems</span> to scale your business.
                    </p>

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row gap-5">
                        <Link to={'/startProject'}>
                            <button className="btn btn-lg bg-neon-blue text-black border-none hover:bg-white hover:scale-105 transition-transform rounded-none font-bold px-10">
                                Start Your Project
                            </button>
                        </Link>
                        <Link to={'/work'}>
                            <button className="btn btn-lg btn-outline text-white border-white/20 hover:bg-white/5 hover:border-white hover:text-white rounded-none font-normal px-10">
                                View Case Studies
                            </button>
                        </Link>
                    </div>
                </div>

                {/* RIGHT COLUMN: The "Visual" (Code Abstract) */}
                <div className="hidden lg:block relative">
                    <div className="relative bg-surface/50 backdrop-blur-md border border-white/10 p-8 rounded-xl shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500">
                        {/* Fake Code Editor Look */}
                        <div className="flex gap-2 mb-6 border-b border-white/5 pb-4">
                            <div className="w-3 h-3 rounded-full bg-red-500"></div>
                            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                            <div className="w-3 h-3 rounded-full bg-green-500"></div>
                        </div>
                        <div className="font-mono text-sm space-y-2">
                            <p className="text-gray-500">// Deploying Optimized SaaS</p>
                            <p className="text-purple-400">const <span className="text-neon-blue">TopOrion</span> = <span className="text-yellow-300">new</span> TechFounder();</p>
                            <p className="text-purple-400">TopOrion.<span className="text-blue-400">focus</span> = [<span className="text-green-400">'RestaurantERP'</span>, <span className="text-green-400">'FitnessSaaS'</span>];</p>
                            <p className="text-purple-400">TopOrion.<span className="text-blue-400">stopLeakage</span>(<span className="text-green-400">true</span>);</p>
                            <p className="text-gray-500 animate-pulse">_</p>
                        </div>
                    </div>

                    <div className="absolute -inset-4 border border-neon-blue/20 rounded-xl z-[-1] transform -rotate-3"></div>
                </div>

            </div>
        </div>
    );
};

export default Hero;